module.exports = __webpack_public_path__ + "img/ellipseOrange.88add16.png";